import { useContext } from 'react';
import { DeleteSubdomainModalContext } from './DeleteSubdomainModalContext';

const useDeleteSubdomainModal = () => {
  const { open } = useContext(DeleteSubdomainModalContext);
  return { open };
};

export default useDeleteSubdomainModal;
